import React from 'react'
import PropTypes from 'prop-types'
import SearchForm from './../../shared/components/searchForm/SearchForm';
import {entitySearchFields} from '../utils/searchFields';
import DataTable from './../../shared/components/table/DataTable';
import {I18n} from 'react-redux-i18n';
import { appModules } from '../../roles/components/UserHasPermission';

const EntitiesPage = ({
    searchFieldsValues,
    universalSearchField,
    handleSearchFieldChange,
    handleUniversalSearchFieldChange,
    handleSortChanged,
    handleSearchSubmit,
    handleSearchClear,
    handleAddButtonClicked,
    data = [],
    entityList,
    onRowClick,
    pages = 0,
    currentPage = 0,
    pageSize,
    totalElements,
    sort: {
        property = "",
        direction = "ASC"
    },
    onPageChange,
    onPageSizeChange,
}) => {

    const columns = [{
            Header: I18n.t("entities.list.name"),
            accessor: "name",
            sortable: true
        }, {
            Header: I18n.t("entities.list.parent"),
            id: "parent",
            accessor: entity => entity.parent == null ? null : entity.parent.name,
            sortable: true
        }, {
            Header: I18n.t("entities.list.type"),
            id: "type",
            accessor: entity => I18n.t("entities.types." + entity.type),
            sortable: true
        }];
        
    return <div className="page_background">
        <SearchForm
            content={entitySearchFields(searchFieldsValues, entityList)}
            universalSearchField={universalSearchField}
            handleFieldChange={handleSearchFieldChange}
            handleUniversalSearchFieldChange={handleUniversalSearchFieldChange}
            handleClear={handleSearchClear}
            handleSubmit={handleSearchSubmit}
            handleAddButtonClicked={handleAddButtonClicked}
            appModule={appModules.ENTITY}
        />
        <DataTable
            //State dependent
            data={data}
            onRowClick={onRowClick}

            //Pagination
            pages = {pages}
            selectedPage = {currentPage}
            pageSize = {pageSize}
            sortDirection={direction}
            sortProperty={property}
            totalElements={totalElements}
            pageSizeOptions = {[10, 20, 50]}
            onPageChange = {onPageChange}
            onPageSizeChange = {onPageSizeChange}
            onSortChanged={handleSortChanged}

            //State independent / Configuration
            columns={columns}
            hasStatusBar={false}
        />
    </div>
}

EntitiesPage.propTypes = {
    searchFieldsValues: PropTypes.object.isRequired,
    handleSearchFieldChange: PropTypes.func,
    handleSearchSubmit: PropTypes.func,
    handleSearchClear: PropTypes.func,
    data: PropTypes.array,
    pages: PropTypes.number
}


export default EntitiesPage;